import { ViewContext } from '@chegg/rio-sdk-web'

import {
  CHEGG_EXPERIENCE,
  CITATION_MACHINE_EXPERIENCE,
  BIBME_EXPERIENCE,
  EASYBIB_EXPERIENCE,
  CHEGG_PRODUCT,
  CITATION_MACHINE_PRODUCT,
  BIBME_PRODUCT,
  EASYBIB_PRODUCT,
  ExperienceMap,
  ProductMap,
} from './types'

import { PAGE_TYPE } from './constants'
import { CHEGG, BIBME, CITATION_MACHINE, EASYBIB, OWL, CHEGG_SIHP, BUSINESS_UNIT, Site } from '../types'

export const productMap: ProductMap = {
  [CHEGG]: CHEGG_PRODUCT,
  [CHEGG_SIHP]: CHEGG_PRODUCT,
  [BIBME]: BIBME_PRODUCT,
  [CITATION_MACHINE]: CITATION_MACHINE_PRODUCT,
  [OWL]: CITATION_MACHINE_PRODUCT, // owl not using RioSDK, but required to satisfy ProductMap type
  [EASYBIB]: EASYBIB_PRODUCT,
}

export const experienceMap: ExperienceMap = {
  [CHEGG]: CHEGG_EXPERIENCE,
  [BIBME]: BIBME_EXPERIENCE,
  [CITATION_MACHINE]: CITATION_MACHINE_EXPERIENCE,
  [OWL]: CITATION_MACHINE_EXPERIENCE, // owl not using RioSDK, but required to satisfy ProductMap type
  [EASYBIB]: EASYBIB_EXPERIENCE,
  [CHEGG_SIHP]: CHEGG_EXPERIENCE,
}

export const getViewContext = (site: Site): ViewContext => ({
  property: BUSINESS_UNIT,
  experience: experienceMap[site],
  view_name: PAGE_TYPE,
})
